import CliqGoLogo from './cliq_go_logo';

export default CliqGoLogo;
